export const SELECTORS = {
	// Modal
	modal: '#snap-blocks-conditions-modal',
	backdrop: '.snap-blocks-modal-backdrop',

	// Buttons
	openButton: '.snap-blocks-conditions-button',
	saveButton: '#snap-blocks-save',
	cancelButton: '#snap-blocks-cancel',
	resetButton: '#snap-blocks-reset',

	// Modal fields
	hook: '.snap-blocks-hook',
	hookName: '.snap-blocks-hook-name',
	priority: '.snap-blocks-priority',

	// Contexts
	contextSelect: '#snap-blocks-context-select',
	context: '.snap-blocks-context',
	contextActive: '.snap-blocks-context.active',

	// Condition rows
	row: '.snap-blocks-condition-row',
	rowActions: '.snap-blocks-condition-actions',

	// Condition controls
	conditionType: '.snap-blocks-condition-type',
	conditionIds: '.snap-blocks-condition-ids',
	conditionIdsWrap: '.snap-blocks-condition-ids-wrap',
	conditionIdsLabel: '.snap-blocks-condition-ids-label',

	// Skip Conditions
	skipConditions: '.snap-blocks-skip-conditions',

	// Row actions
	btnRemove: '.snap-blocks-condition-remove',
	btnAdd: '.snap-blocks-condition-add',
};
